
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurant/[menu]",
      function () {
        return require("private-next-pages/restaurant/[menu].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurant/[menu]"])
      });
    }
  